const baseEvent = {
  eventCategory: 'Loyalty',
  customMetrics: {},
  customVariables: {},
  _clear: true
}

const getLabel = (reward) =>
  reward.issueText ? `${reward.issueText} - ${reward.amount}` : reward?.amount?.toString()

export default {
  // https://digital.vfc.com/wiki/spaces/AN/pages/356779924/Loyalty+Contents#LoyaltyContents-RewardsApplyandRemove
  onRewardApply: (reward) => ({
    ...baseEvent,
    event: 'loadEventData',
    eventAction: 'Rewards Apply',
    nonInteractive: true,
    eventLabel: getLabel(reward)
  }),
  onRewardRemove: (reward) => ({
    ...baseEvent,
    event: 'loadEventData',
    eventAction: 'Rewards Remove',
    nonInteractive: true,
    eventLabel: getLabel(reward)
  }),
}
